import React from 'react';
import { Carousel, CarouselItem, Heading } from '@americanexpress/dls-react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { InspirationFilterButtons } from '../InspirationFilterButtons/InspirationFilterButtons';
import { InspirationCard } from '../InspirationCards/InspirationCard';
import { MODULE_NAME } from '../../../constants/modules';

export const InspirationSkeletonCards = ({ reference, hasLoadedIntoViewport }) => {
  const { formatMessage } = useIntl();
  const skeletonArray = [0, 1, 2, 3];

  return (
    <section
      className="container pad-1-t pad-4-b position-relative height-full"
      ref={reference}
      data-testid={`${MODULE_NAME}-homepage-get-inspired-skeleton-loader-container`}
    >
      <Heading level={2} variant="sans-medium-regular" className="text-align-left pad-3-b">
        {formatMessage({ id: 'getInspired.heading' })}
      </Heading>
      <div className="pad-1">
        <div style={{ opacity: 0.5 }}>
          <InspirationFilterButtons
            isInViewport={hasLoadedIntoViewport}
          />
          <div className="row hidden-md-down">
            {skeletonArray.map((item) => (
              <div className="col-lg-3" key={`inspiration-card-skeleton-${item}`}>
                <InspirationCard
                  key={`inspiration-card-key-${item}`}
                />
              </div>
            ))}
          </div>
          <div className="flex hidden-lg-up">
            <Carousel
              id="inspiration-carousel-skeleton"
              isSlideFullWidth={false}
              key="inspiration-carousel-skeleton"
              isInfinite={true}
            >
              {skeletonArray.map((item) => (
                <CarouselItem id={`inspiration-carousel-item-skeleton-${item}`} key={`inspiration-carousel-item-skeleton-${item}`}>
                  <InspirationCard
                    key={`inspiration-card-carousel-key-${item}`}
                  />
                </CarouselItem>
              ))};
            </Carousel>
          </div>
        </div>
      </div>
    </section>
  );
};

InspirationSkeletonCards.propTypes = {
  reference: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]).isRequired,
  hasLoadedIntoViewport: PropTypes.bool.isRequired,
};
